import React from 'react'
import Item from './item'
import GenericItem from '../../../../../../images/genericFood.png'
const FoodListItem = (props) => {
  const item = props.item
  const currentFood = new Item(item)
  const getProtein = item.itemType === 'recipe' ? currentFood.getRecipeProtein().toFixed(1) : currentFood.getProtein().toFixed(1) 
  const getCarbs = item.itemType === 'recipe' ? currentFood.getRecipeCarbs().toFixed(1) : currentFood.getCarbs().toFixed(1)
  const getFat = item.itemType === 'recipe' ? currentFood.getRecipeFat().toFixed(1) : currentFood.getFat().toFixed(1)
    
  if (item)
    return (
      <button className="tracker-item-timeline" style={{cursor: item.itemType === 'recipe' ? 'pointer' : 'default', position: 'relative'}} onClick={() => props.onClick()}>
        <img className="tracker-item-thumbnail" src={item.thumbnailUrl ? item.thumbnailUrl : GenericItem} alt="food-thumbnail" />
        <div className="tracker-item-data">
          <p className="name">{item.name}</p>
          {/* <p className="name">{item.name}{item.itemType === 'alcohol' && <Icon style={{ verticalAlign: 'bottom' }}>local_bar</Icon>}{item.itemType === 'recipe' && <img style={{ marginLeft: '5px', width: '17px', display: 'inline'}} src={ChefSvg} alt="chef"/>}</p> */}
          <div className="macros-container">
            <p className="unit">{item.serving} {item.unit}</p>
            <div className="macros">
              {item.itemType !== 'alcohol' && <p className="macro">{getProtein} P</p>}
              <p className="macro">{getCarbs} C</p>
              <p className="macro">{getFat} F</p>
            </div>
          </div>
        </div>    
      </button>
    )
}

export default FoodListItem
